import { useCallback } from 'react';

import { getNextHighlightedIndex } from './getNextHighlightedIndex';

type UseInputKeyDownParams = {
	open: boolean;
	highlightedIndex: number;
	optionCount: number;
	handleOpen: () => void;
	handleClose: () => void;
	handleHighlightIndex: (index: number) => void;
	handleSelect: (event: React.KeyboardEvent<HTMLInputElement>, index: number) => void;
};

export function useInputKeyDown({
	open,
	highlightedIndex,
	optionCount,
	handleOpen,
	handleClose,
	handleHighlightIndex,
	handleSelect,
}: UseInputKeyDownParams): (event: React.KeyboardEvent<HTMLInputElement>) => void {
	return useCallback(
		// oxlint-disable-next-line max-statements
		(event: React.KeyboardEvent<HTMLInputElement>) => {
			switch (event.key) {
				case 'ArrowDown':
				case 'ArrowUp': {
					event.preventDefault(); // prevent page scroll / cursor jumping to the start of the input text
					// if popover isn't open, open and return
					if (!open) {
						handleOpen();
						return;
					}

					// else start navigating the listbox
					handleHighlightIndex(getNextHighlightedIndex(event.key, highlightedIndex, optionCount));
					break;
				}
				case 'Enter': {
					event.preventDefault(); // prevent submit
					if (!open) return;

					if (highlightedIndex !== -1) {
						handleSelect(event, highlightedIndex);
					}
					handleClose();
					break;
				}
				case 'Escape': {
					handleClose();
					break;
				}
				default:
					// do nothing
					break;
			}
		},
		[open, highlightedIndex, handleHighlightIndex, optionCount, handleOpen, handleClose, handleSelect],
	);
}
